import VcomProvider from '../../../VcomProvider';

function getDefault() {
  return {
    id: null,
    systemId: VcomProvider.adminSystemId,
    access: '',
    safetyBriefing: '',
    hazardNotes: '',
  };
}

function makeMasterData(masterData) {
  return {
    ...getDefault(),
    ...masterData,
  };
}

const MasterDataFactory = {
  makeMasterData,
};

export default MasterDataFactory;
